import React from "react";
import {Link} from "react-router-dom";

const WebGLUnavailable = React.memo(() =>
  <div className="flex-fill d-flex flex-column justify-content-center align-items-center"
       style={{backgroundColor: "#000"}}>
    <div
      className="text-center"
      style={{
        color: "#fff",
        backgroundColor: "rgba(255, 255, 255, 0.1)",
        padding: "2rem",
        borderRadius: "1rem",
        boxShadow: "0 0 15px rgba(255, 255, 255, 0.3)",
        maxWidth: "500px",
      }}
    >
      <h2 className="mb-3">WebGL Not Available</h2>
      <p>
        Your browser cannot initialize WebGL, which is required to view the network visualization. Please enable
        hardware acceleration, try a different browser, or visit&nbsp;
        <a href="https://get.webgl.org/" target="_blank" rel="noopener noreferrer">get.webgl.org</a> for more
        information.
      </p>
      <p>
        You can still explore the data in <Link to="/list">list view</Link>.
      </p>
    </div>
  </div>
);

export default WebGLUnavailable;